import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-bar" }
const _hoisted_2 = { style: {"margin-top":"12px"} }
const _hoisted_3 = { style: {"margin-top":"12px","display":"flex"} }

import { OioPagination, OioForm, OioFormItem, OioRow, OioCol, OioInput, OioButton, OioTag } from '@kunlun/vue-ui-antd';
import { computed, reactive, ref, watch } from 'vue';
import { itemClacEnum, priceTypeEnum } from '../../../../constants/enum';
import { exportModelExcelFile } from '../../../../utils/excel';
import { MyFormM2MTableFieldWidget } from './MyFormM2MTableFieldWidget';

interface IProps {
  _instance: MyFormM2MTableFieldWidget;
  _dataSource: any[];
  loading: boolean;
  mountedFlag: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MyFormM2MTableField',
  props: {
    _instance: null,
    _dataSource: { default: () => [] },
    loading: { type: Boolean, default: false },
    mountedFlag: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { _instance: MyFormM2MTableFieldWidget, _dataSource: any[], loading: boolean, mountedFlag: boolean }



const tableRef = ref<any>(null);

const displayTableData = computed(() => {
  return state.viewTableData.slice(
    (state.pagination.current - 1) * state.pagination.pageSize,
    state.pagination.current * state.pagination.pageSize
  );
});

const state = reactive({
  dataSource: [] as any[],
  viewTableData: [] as any[],
  pagination: {
    current: 1,
    pageSize: 15
  },
  selectedRows: [] as any[],
  searchForm: {
    merchBillName: '',
    code: '',
    outCode: ''
  }
});

const checkboxChangeEvent = () => {
  state.selectedRows = tableRef.value?.getCheckboxRecords();
};

const handleExport = () => {
  // const includesFields = ['outCode', 'itemNumber', 'name'];
  // @ts-ignore
  const exportModel = props._instance.runtimeSubviewContext.model;
  // exportModel.modelFields = exportModel.modelFields.filter((i) => includesFields.includes(i.data));
  exportModelExcelFile(props._dataSource, exportModel, { filename: `方案活动商品明细导出_${Date.now()}.xlsx` });
};

const handleSearch = () => {
  state.pagination.current = 1;
  state.pagination.pageSize = 15;

  // 根据搜索条件过滤数据
  state.viewTableData = props._dataSource.filter((item) => {
    return (
      item.merchBillName.includes(state.searchForm.merchBillName) &&
      item.code.includes(state.searchForm.code) &&
      item.outCode.includes(state.searchForm.outCode)
    );
  });
};

const handleReset = () => {
  state.searchForm.merchBillName = '';
  state.searchForm.code = '';
  state.searchForm.outCode = '';
  initData();
};

const initData = () => {
  state.viewTableData = props._dataSource;
};

const stopWatch = watch(
  () => props.mountedFlag,
  (val) => {
    if (val) {
      initData();
      stopWatch();
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_oio_spin = _resolveComponent("oio-spin")!

  return (_openBlock(), _createBlock(_component_oio_spin, { loading: __props.loading }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(OioForm), { layout: "horizontal" }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "商品清单名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: state.searchForm.merchBillName,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((state.searchForm.merchBillName) = $event)),
                          allowClear: "",
                          onKeyup: _withKeys(handleSearch, ["enter"])
                        }, null, 8, ["value", "onKeyup"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "平台商品编码" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: state.searchForm.code,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((state.searchForm.code) = $event)),
                          allowClear: "",
                          onKeyup: _withKeys(handleSearch, ["enter"])
                        }, null, 8, ["value", "onKeyup"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "ERP商品编码" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: state.searchForm.outCode,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((state.searchForm.outCode) = $event)),
                          allowClear: "",
                          onKeyup: _withKeys(handleSearch, ["enter"])
                        }, null, 8, ["value", "onKeyup"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: " " }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioButton), {
                          type: "primary",
                          onClick: handleSearch
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("搜索")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(OioButton), {
                          style: {"margin-left":"12px"},
                          onClick: handleReset
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重置")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: handleExport
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_vxe_table, {
        "header-align": "center",
        border: "",
        ref_key: "tableRef",
        ref: tableRef,
        height: "252",
        size: "mini",
        "column-config": { resizable: true },
        data: _unref(displayTableData),
        "edit-config": { trigger: 'click', mode: 'cell' },
        "scroll-x": { enabled: false },
        "scroll-y": { enabled: true, gt: 0, oSize: 20 },
        "checkbox-config": { checkField: 'isSelected', reserve: true },
        "row-config": { keyField: 'id' },
        onCheckboxChange: _cache[3] || (_cache[3] = () => checkboxChangeEvent()),
        onCheckboxAll: _cache[4] || (_cache[4] = () => checkboxChangeEvent()),
        style: {"margin-top":"12px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_column, {
            type: "checkbox",
            fixed: "left",
            width: "50",
            align: "center"
          }),
          _createVNode(_component_vxe_column, {
            field: "merchBillName",
            title: "商品清单名称"
          }),
          _createVNode(_component_vxe_column, {
            field: "code",
            title: "平台商品编码"
          }),
          _createVNode(_component_vxe_column, {
            field: "outCode",
            title: "ERP商品编码"
          }),
          _createVNode(_component_vxe_column, {
            field: "name",
            title: "商品名称",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, {
            field: "itemNumber",
            title: "货号",
            "show-overflow": ""
          }),
          _createVNode(_component_vxe_column, { title: "价格类型" }, {
            default: _withCtx((scope) => [
              (!!_unref(priceTypeEnum)[scope.row.priceType])
                ? (_openBlock(), _createBlock(_unref(OioTag), {
                    key: 0,
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(priceTypeEnum)[scope.row.priceType]), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, { title: "让利/不让利" }, {
            default: _withCtx((scope) => [
              (!!_unref(itemClacEnum)[scope.row.itemCalc])
                ? (_openBlock(), _createBlock(_unref(OioTag), {
                    key: 0,
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(itemClacEnum)[scope.row.itemCalc]), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            field: "specialPrice",
            title: "特价价格"
          }),
          _createVNode(_component_vxe_column, {
            field: "specialDiscountRate",
            title: "特价扣率"
          }),
          _createVNode(_component_vxe_column, {
            field: "specialDeductionRate",
            title: "特殊扣率"
          }),
          _createVNode(_component_vxe_column, {
            field: "limitBuyNum",
            title: "限购数量"
          }),
          _createVNode(_component_vxe_column, {
            field: "promotionTotalNum",
            title: "秒杀库存"
          }),
          _createVNode(_component_vxe_column, { title: "赠品包装" }, {
            default: _withCtx((scope) => [
              (!!scope.row.giftPackage)
                ? (_openBlock(), _createBlock(_unref(OioTag), {
                    key: 0,
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.giftPackage), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_column, {
            field: "giftNumber",
            title: "赠品数量"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(OioPagination), {
          style: {"margin-left":"auto"},
          current: state.pagination.current,
          "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((state.pagination.current) = $event)),
          pageSize: state.pagination.pageSize,
          "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((state.pagination.pageSize) = $event)),
          pageSizeOptions: [10, 15, 30, 50, 100, 200],
          "show-size-changer": "",
          total: state.viewTableData.length,
          "show-total": (total) => `${total} 条`
        }, null, 8, ["current", "pageSize", "total", "show-total"])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})